// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__NK7tg","rotate":"styles_rotate__ge1RO","rotate-reverse":"styles_rotate-reverse__slrSW"};